module.exports = __webpack_public_path__ + "static/img/jiankang_.bb8aeea6.png";